import { Colors, InlineChildren, Spacing, StackChildren, Text } from '@doordash/design-language';
import Tag from '@doordash/component-tag';
import styled from 'styled-components';

export const ModifiersGroup = styled(Text).attrs({
  styles: Text.Styles.Regular12,
  color: Colors.SystemGrey80,
})`
  margin-top: ${Spacing.None}px !important;
  font-size: var(--bose-cart-item_list__item-mod-size);
  font-weight: var(--bose-cart-item_list__item-mod-weight);
`;

export const PriceContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 5px;
`;

export const ItemLabelText = styled(Text).attrs({
  color: Colors.SystemGrey95,
  styled: Text.Styles.Bold14,
})`
  font-size: var(--bose-cart-item_list__item-name-size);
  font-weight: var(--bose-cart-item_list__item-name-weight);
  display: inline;
`;

export const PriceText = styled(Text).attrs({
  styles: Text.Styles.Regular12,
  color: Colors.SystemBlack,
})<{ hasBeenRefunded?: boolean; hasBOGO?: boolean }>`
  margin-top: ${Spacing.None}px !important;
  font-size: var(--bose-cart-item_list__item-price-size);
  font-weight: var(--bose-cart-item_list__item-price-weight);

  ${({ hasBeenRefunded = false, hasBOGO = false }) =>
    (hasBOGO || hasBeenRefunded) &&
    `
      text-decoration: line-through;
      color: ${Colors.SystemGrey40};
  `}
`;

export const ListItemWrapper = styled(InlineChildren)`
  justify-content: space-between;
  align-items: center;
  margin: ${Spacing.Small}px ${Spacing.None}px ${Spacing.None} ${Spacing.None}px;
`;

export const ListItemDescription = styled(StackChildren).attrs({ size: Spacing.None })`
  max-width: unset;
  flex-grow: 1;
`;

export const QtyIndicatorContainer = styled.div`
  padding: ${Spacing.XxSmall}px;
`;

export const QtyIndicator = styled.div<{ dark?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.2);
  width: ${Spacing.XLarge}px;
  height: ${Spacing.XLarge}px;
  background-color: ${({ dark }) => (dark ? 'var(--color-neutral__body)' : 'var(--color-dd-system-white)')};
  color: ${({ dark }) => (dark ? 'var(--color-dd-system-white)' : 'var(--color-neutral__body)')};
  font-weight: 700;

  > div {
    width: 7px;
    height: 7px;
  }
`;
